import React, { useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import { ErrorOutline as ErrorIcon } from '@mui/icons-material'
import type { StreamingError } from '../types'

interface AgentErrorBannerProps {
    error: StreamingError
    onRetry?: () => void
}

export const AgentErrorBanner: React.FC<AgentErrorBannerProps> = ({
    error,
    onRetry,
}) => (
    <Box
        role="alert"
        sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            p: 1.5,
            mb: 1,
            borderRadius: 1,
            border: '1px solid var(--error-color, #fecaca)',
            background: 'var(--error-bg, #fee2e2)',
        }}
    >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
            <ErrorIcon
                sx={{ fontSize: 18, color: 'var(--error-color, #ef4444)', mt: 0.25 }}
            />
            <Box sx={{ flex: 1 }}>
                <Typography
                    sx={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: 'var(--error-color, #991b1b)',
                    }}
                >
                    {error.type === 'rate_limit' ? 'Rate limited' : 'Agent error'}
                </Typography>
                <Typography
                    sx={{
                        fontSize: 12,
                        color: 'var(--error-color, #991b1b)',
                        mt: 0.25,
                    }}
                >
                    {error.message}
                </Typography>
                {error.retryAfterMs != null && error.retryAfterMs > 0 && (
                    <Typography
                        sx={{
                            fontSize: 11,
                            color: 'var(--main-text-secondary, #64748b)',
                            mt: 0.5,
                        }}
                    >
                        Retry after {Math.ceil(error.retryAfterMs / 1000)}s
                    </Typography>
                )}
            </Box>
        </Box>
        {error.recoverable && onRetry && (
            <Button
                size="small"
                variant="outlined"
                onClick={onRetry}
                sx={{
                    alignSelf: 'flex-start',
                    fontSize: 11,
                    textTransform: 'none',
                    borderColor: 'var(--error-color, #ef4444)',
                    color: 'var(--error-color, #991b1b)',
                }}
            >
                Try again
            </Button>
        )}
    </Box>
)

export default AgentErrorBanner
